import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=9f950450&scoped=true"
import script from "./sidebar.vue?vue&type=script&lang=ts"
export * from "./sidebar.vue?vue&type=script&lang=ts"
import style0 from "./sidebar.vue?vue&type=style&index=0&id=9f950450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.26_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_wdrzbp32twlk6ul2h2xp3hbjle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f950450",
  null
  
)

export default component.exports